export default __webpack_public_path__ + "static/media/4.a62a7f86.svg";